/* eslint-disable jsx-a11y/alt-text */
import { Button, ButtonColor, ButtonProps } from '@doveit/lego';
import React from 'react';
import Step, { StepProps } from '../step/Step';
import * as styles from './StepsToSuccess.style';

export interface StepsToSuccessProps {
  steps: StepProps[],
  successStep: {
    title: string,
    description: string,
    image: {
      src: string,
      alt: string,
    },
    cta: ButtonProps,
  },
}

const StepsToSuccess: React.FC<StepsToSuccessProps> = ({
  steps,
  successStep,
}) => (
  <ol css={styles.base}>
    {steps.map((step) => (
      <li
        key={step.position}
        $size={{ MD: 1 / 3 }}
        css={styles.step}
      >
        <Step
          {...step}
          cta={step.cta}
        />
      </li>
    ))}
    <li
      $size={{ MD: 2 / 3 }}
      css={styles.step}
    >
      <div css={styles.successStep}>
        <div>
          <h4 css={styles.successStepTitle}>
            {successStep.title}
          </h4>
          <div
            css={styles.successStepDescription}
            dangerouslySetInnerHTML={{ __html: successStep.description }}
          />
          <Button
            color={ButtonColor.SECONDARY}
            {...successStep.cta}
          />
        </div>
        <div css={styles.successStepImageWrapper}>
          <img
            {...successStep.image}
            css={styles.howItWorksCTAImage}
          />
        </div>
      </div>
    </li>
  </ol>
);

export default StepsToSuccess;
